import { render } from "./AdminQueries.vue?vue&type=template&id=65922bbd&scoped=true"
import script from "./AdminQueries.vue?vue&type=script&lang=js"
export * from "./AdminQueries.vue?vue&type=script&lang=js"

import "./AdminQueries.vue?vue&type=style&index=0&id=65922bbd&scoped=true&lang=css"
import "./AdminQueries.vue?vue&type=style&index=1&id=65922bbd&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65922bbd"]])

export default __exports__